/**
 * Created by linjianxi on 2017/6/8.
 */
import * as type from './mutation-type'
import * as http from '../../../utils/common'

/**
 * 获取当月收益汇总
 * @param commit
 * @param params
 * @constructor
 */
export const GetUserCashMonth = ({commit}, params) => {
  http.post({
    url: '/api/FundVirtualCy/GetUserCashMonth',
    data: params.data,
    succ: function (res) {
      if (res.result === 1) {
        commit(type.GETUSERCASHMONTH, res)
      } else {
        mui.alert(res.message)
      }
    }
  }, params._this.$store.commit)
}

/**
 * 提现历史记录
 * @param commit
 * @param params
 */
export const cashDetailList = ({commit}, params) => {
  http.post({
    url: '/api/HqbCashApplySearch/GetHqbCashApplyList',
    data: params.data,
    succ: function (res) {
      if (res.result === 1) {
        commit(type.CASHDETAILLIST, {res: res, _this: params._this})
      } else {
        mui.alert(res.message)
      }
    }
  }, params._this.$store.commit)
}

/**
 * 浪票收支记录
 * @param commit
 * @param params
 */
export const virtualCyList = ({commit}, params) => {
  http.post({
    url: '/api/FundVirtualCy/GetVirtualCyList',
    data: params.data,
    succ: function (res) {
      if (res.result === 1) {
        commit(type.VIRTUALLIST, {res: res, _this: params._this})
      } else {
        mui.alert(res.message)
      }
    }
  }, params._this.$store.commit)
}



// WEBPACK FOOTER //
// ./src/vuex/modules/hqpord_detail/actions.js